<template>
  <v-container grid-list-xs>
    <v-row justify="space-around">
      <v-dialog
                v-model="dialogReceipt"
                width="70%"
                scrollable
                :scrim="false"
                transition="dialog-bottom-transition"
                @closed="receiptClosed">
        <v-card>
          <v-card-text class="p-10">
            <div v-html="receiptContent"></div>
          </v-card-text>
          <v-card-actions class="justify-start">
            <v-tooltip location="bottom" text="Imprimir">
              <template v-slot:activator="{ props }">
                <v-btn v-bind="props" icon variant="plain" density="compact" @click="printReceipt">
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
            <v-tooltip location="bottom" text="Exportar PDF">
              <template v-slot:activator="{ props }">
                <v-btn v-bind="props" icon variant="plain" density="compact" @click="downloadReceipt">
                  <v-icon>mdi-file-pdf-box</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-btn variant="text"
                   @click="dialogReceipt = false">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="false">
        <v-form :submit="submitSearch">
          <v-card color="grey-lighten-2">
            <v-card-title>
              Histórico de contas
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-select
                            :items="[50, 100, 200, 500]"
                            v-model="filters.itemsPerPage"
                            label="Resultados por página"
                            density="compact"
                            hide-details></v-select>
                </v-col>
              </v-row>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" type="submit"><v-icon class="mr-2">mdi-magnify</v-icon>Atualizar lista</v-btn>
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-form>
      </v-col>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-row align="center">
              <v-col cols="9" v-if="showSelectHeaders">
                <v-select
                          label="Campos da tabela"
                          item-title="title"
                          return-object
                          :items="headers"
                          hide-details
                          multiple
                          clearable
                          chips
                          v-model="selectedHeaders"
                          density="compact"
                          @update:modelValue="saveSelectedHeaders"></v-select>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="1" style="min-height:71px;">
                <v-tooltip location="top">
                  <template v-slot:activator="{ props }">
                    <v-btn icon density="compact"
                           v-bind="props"
                           variant="text">
                      <v-icon color="grey-lighten-1"
                              @click="showSelectHeaders = !showSelectHeaders">
                        mdi-cog
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Configurar Cabeçalhos</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-card-title>
          <v-data-table
                        v-model="selectedObjects"
                        :headers="selectedHeaders"
                        :items="lstObjects"
                        :search="searchFilter"
                        :items-per-page="filters.itemsPerPage"
                        return-object
                        class="elevation-1"
                        hide-default-footer>
            <template v-slot:bottom>
              <div class="text-center pt-2">
                <v-pagination
                              :disabled="requestingApi"
                              v-model="page"
                              :length="maxPage"></v-pagination>
              </div>
            </template>
            <template v-slot:item.is_human="{ value }">
              <span>{{ value ? "PF" : "PJ" }}</span>
            </template>
            <template v-slot:item.type="{ value }">
              <span>{{
                $LEGAL_PEOPLE_TYPES_DIC[value]
                ? $LEGAL_PEOPLE_TYPES_DIC[value].label
                : value
              }}</span>
            </template>
            <template v-slot:item.status="{ value }">
              <v-chip
                      :color="$INVOICE_STATUS_DIC[value]?.color || 'grey'">{{
                        $INVOICE_STATUS_DIC[value]
                        ? $INVOICE_STATUS_DIC[value].label
                        : value
                      }}</v-chip>
            </template>
            <template v-slot:item.payment_date="{ item }">
              <span
                    v-if="item.payment_date"
                    :class="getTextColorClassFromInvoiceDueDate(item)">{{
                      $moment.parseZone(item.payment_date).format("DD/MM/YYYY")
                    }}</span>
            </template>
            <template v-slot:item.due_date="{ item, value }">
              <span :class="getTextColorClassFromInvoiceDueDate(item)">{{
                $moment.parseZone(value).format("DD/MM/YYYY")
              }}</span>
            </template>
            <template v-slot:item.amount="{ item }">
              <span>{{
                $filters.currency(getAmountFromInvoice(item), 'BRL')
              }}</span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-menu>
                <template v-slot:activator="{ props }">
                  <v-btn icon variant="text" v-bind="props"><v-icon>mdi-dots-vertical</v-icon></v-btn>
                </template>
                <v-list>
                  <v-list-item v-if="item.status == $INVOICE_STATUS_DIC.PAID.value"
                               @click="receipt(item)">
                    <v-list-item-title>
                      <v-icon color="primary" class="mr-2">mdi-eye</v-icon>
                      Ver recibo
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import DialogWriteOff from "./DialogWriteOff.vue";
import AutocompleteSelectGroup from "./AutocompleteSelectGroup.vue";
import AutocompleteSelectInvoiceStatus from "./AutocompleteSelectInvoiceStatus.vue";
import DialogCreateInvoice from "./DialogCreateInvoice.vue";
import AutocompleteSelectLegalPeople from "./AutocompleteSelectLegalPeople.vue";
import api from '@/services'
export default {
  components: {
    AutocompleteSelectGroup,
    AutocompleteSelectInvoiceStatus,
    DialogCreateInvoice,
    DialogWriteOff,
    AutocompleteSelectLegalPeople,
  },
  props: {
    user: Object,
  },
  data() {
    return {
      requestingApi: false,
      tab: 1,
      headers: [
        { title: "ID", align: "start", key: "id", sortable: true },
        { title: "Descrição", align: "start", key: "description", sortable: true },
        { title: "Para", align: "start", key: "to.name", sortable: true },
        { title: "Valor", align: "end", key: "amount", sortable: true },
        { title: "Pagamento", align: "end", key: "payment_date", sortable: true },
        { title: "Ações", key: "actions", align: "end", sortable: false },
      ],
      selectedHeaders: [],
      showSelectHeaders: false,
      lstObjects: [],
      selectedObjects: [],
      filters: {
        withUser: true,
        special_filters: [],
        statuses: [],
        itemsPerPage: 30,
        is_human: null,
        type: null,
        group_id: null,
        legal_people_to_ids: [],
      },
      editModel: {},
      newInvoiceRequest: {
        invoice: {},
      },
      checkout: {
        payment_method: {},
        payment_date: new Date(),
        invoices: [],
        invoice: {},
        invoices_ids: [],
        validation: {
          total: 0,
        },
      },
      dialogCreateEdit: false,
      searchFilter: null,
      page: 1,
      maxPage: 1,
      currentInvoice: null,
      receiptContent: '',
      dialogReceipt: false,
    };
  },
  created() {
    var vm = this;
    vm.loadParameters();
    vm.submitSearch()
  },
  mounted() { },
  activated() { },
  methods: {
    getTextColorClassFromInvoiceDueDate(invoice) {
      var vm = this;
      let _class = "";
      if (invoice.status == vm.$INVOICE_STATUS_DIC.CANCELED.value) {
        _class = "";
      } else {
        let _dueDate = vm.$moment.parseZone(invoice.due_date).startOf("day");
        if (invoice.payment_date) {
          let _paymentDate = vm.$moment
            .parseZone(invoice.payment_date)
            .startOf("day");
          if (_dueDate < _paymentDate) {
            _class = "text-red";
          } else if (
            _dueDate.format("DD/MM/YYYY") == _paymentDate.format("DD/MM/YYYY")
          ) {
            _class = "text-orange";
          } else if (_dueDate > _paymentDate) {
            _class = "text-green";
          }
        } else {
          let _today = vm.$moment.parseZone().startOf("day");
          if (_dueDate < _today) {
            _class = "text-red";
          } else if (
            _dueDate.format("DD/MM/YYYY") == _today.format("DD/MM/YYYY")
          ) {
            _class = "text-orange";
          } else if (_dueDate > _today) {
            _class = "text-blue";
          }
        }
      }
      return _class;
    },
    getAmountFromInvoice(invoice) {
      var vm = this;
      if (invoice.paid_amount) {
        return invoice.paid_amount;
      } else {
        let _dueDate = vm.$moment.parseZone(invoice.due_date).startOf("day");
        let _today = vm.$moment.parseZone().startOf("day");
        let _amount = invoice.amount;
        if (_dueDate > _today) {
          _amount -= invoice.early_payment_discount || 0
        } else if (
          _dueDate.format("DD/MM/YYYY") == _today.format("DD/MM/YYYY")
        ) {
          _amount -= invoice.early_payment_discount || 0
        }
        return _amount
      }
    },
    saveSelectedHeaders() {
      var vm = this;
      try {
        localStorage.setItem(
          "_invoice_history_list_headers",
          JSON.stringify(vm.selectedHeaders)
        );
      } catch (error) {
        console.error(error);
      }
    },
    loadParameters() {
      var vm = this;
      let _itemsPerPage = localStorage["_invoice_history_itemsPerPage"];
      vm.filters.itemsPerPage = parseInt(_itemsPerPage || 10);
      vm.filters.statuses = [vm.$INVOICE_STATUS_DIC.PAID.value]
      try {
        let _headers = localStorage["_invoice_history_list_headers"];
        vm.selectedHeaders = _headers ? JSON.parse(_headers) : vm.headers;
      } catch (error) {
        vm.selectedHeaders = vm.headers;
      }
    },
    submitSearch(page) {
      var vm = this;
      vm.selectedObjects = [];
      if (!vm.requestingApi) {
        vm.requestingApi = true;
        vm.page = page || 1;
        return new Promise((resolve, reject) => {
          api.invoice.myInvoices(vm.filters, page || 1)
            .then((result) => {
              vm.lstObjects = result?.data;
              vm.maxPage = Math.ceil(
                (result?.total || 1) / (result?.per_page || 30)
              );
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
    createdObject(val) {
      var vm = this;
      vm.lstObjects.unshift(val);
    },
    receipt(invoice) {
      const vm = this;

      if (invoice?.receipt_id) {
        if (!vm.requestingApi) {

          vm.requestingApi = true;
          return new Promise((resolve, reject) => {
            api.receipt.viewReceipt(invoice.receipt_id)
              .then((result) => {
                vm.currentInvoice = invoice;
                vm.receiptContent = result;
                vm.dialogReceipt = true;
              })
              .catch((err) => {
                if (err.message) {
                  vm.$notify({
                    type: "error",
                    text: err.message,
                  });
                }
              })
              .finally(() => {
                vm.requestingApi = false;
              });
          });
        }
      }
    },
    downloadReceipt() {
      const vm = this;

      if (vm.currentInvoice?.receipt_id) {
        if (!vm.requestingApi) {

          vm.requestingApi = true;
          return new Promise((resolve, reject) => {
            api.pdf.downloadReceipt(vm.currentInvoice.receipt_id)
              .then((result) => {
                // create file link inx browser's memory
                const href = URL.createObjectURL(result);

                // create "a" HTML element with href to file & click
                const link = document.createElement('a');
                link.href = href;

                link.setAttribute('download', `Recibo_${vm.currentInvoice.receipt_id}_${vm.$moment(new Date()).format("YYYYMMDD-HHmmss")}.pdf`); //or any other extension
                document.body.appendChild(link);
                link.click();

                // clean up "a" element & remove ObjectURL
                document.body.removeChild(link);
                URL.revokeObjectURL(href);
              })
              .catch((err) => {
                if (err.message) {
                  vm.$notify({
                    type: "error",
                    text: err.message,
                  });
                }
              })
              .finally(() => {
                vm.requestingApi = false;
              });
          });
        }
      }
    },
    printReceipt() {
      const vm = this;
      // Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

      WinPrint.document.write(`<!DOCTYPE html>${vm.receiptContent}`);
      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },
    receiptClosed() {
      const vm = this;

      vm.currentInvoice = null;
      vm.receiptContent = '';
      vm.dialogReceipt = false;
    }
  },
  computed: {},
  watch: {
    "filters.itemsPerPage"(newVal) {
      localStorage["_invoice_history_itemsPerPage"] = newVal;
    },
    page(newVal) {
      var vm = this;
      if (!isNaN(newVal)) {
        vm.submitSearch(newVal);
      }
    },
    dialogReceipt(newVal) {
      const vm = this;

      if (newVal != null && !newVal) {
        vm.receiptClosed();
      }
    }
  },
};
</script>